// Copyright Epic Games, Inc. All Rights Reserved.
import { HTTP_STATUS_CODES } from '@constants/http-status-codes';
import type { FlagDenialMessage } from '@constants/gated-flags';
import { DEFAULT_FLAG_DENIAL_MESSAGE, FLAG_DENIAL_MESSAGES } from '@constants/gated-flags';

export const create403RedirectUrl = (platform: string, basePath: string, asPath: string): string =>
  `/403?platform=${platform}&resolvedUrl=${basePath}${asPath.split('?')[0]}`;

export const createProtectedRedirectUrl = (basePath: string, asPath: string, flag?: string): string => {
  const flagParam = flag ? `&flag=${encodeURIComponent(flag)}` : '';

  return `/AccessDeniedPage?resolvedUrl=${basePath}${asPath.split('?')[0]}${flagParam}`;
};

// The denial page only ever receives the flag as a query param, so treat it as an
// untrusted lookup key: anything unrecognised resolves to the generic message.
// hasOwnProperty, not a bare index — `?flag=constructor` would otherwise resolve to
// an inherited Object.prototype member and render a broken page.
export const getFlagDenialMessage = (flag: string | string[] | undefined): FlagDenialMessage => {
  const flagName = Array.isArray(flag) ? flag[0] : flag;

  if (!flagName || !Object.prototype.hasOwnProperty.call(FLAG_DENIAL_MESSAGES, flagName)) {
    return DEFAULT_FLAG_DENIAL_MESSAGE;
  }

  return FLAG_DENIAL_MESSAGES[flagName];
};

export const checkIsAccessDenied = (errorStatusCode: number): boolean =>
  errorStatusCode === HTTP_STATUS_CODES['403'] || errorStatusCode === HTTP_STATUS_CODES['404'];
